import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=20a4c8ac&scoped=true&"
import script from "./Results.vue?vue&type=script&lang=js&"
export * from "./Results.vue?vue&type=script&lang=js&"
import style0 from "./Results.vue?vue&type=style&index=0&id=20a4c8ac&prod&lang=css&"
import style1 from "./Results.vue?vue&type=style&index=1&id=20a4c8ac&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a4c8ac",
  null
  
)

export default component.exports